import { ComponentRef, Directive, EventEmitter, Input, OnInit, Output, Type, ViewContainerRef } from '@angular/core';
import { CheckboxFilterFieldComponent } from './checkbox/filter-field-checkbox.component';
import { DatePickerFilterFieldComponent } from './date-picker/filter-field-date-picker.component';
import { FilterField } from './filter';
import { FilterFieldComponent } from './filter-field.component';
import { ItemsAndStatusFilterFieldComponent } from './items-and-status/filter-field-items-and-status.component';
import { MultiItemsAndStatusFilterFieldComponent } from './multi-items-and-status/filter-field-multi-items-and-status.component';
import { MultiSelectFilterFieldComponent } from './multi-select/filter-field-multi-select.component';
import { RadioFilterFieldComponent } from './radio/filter-field-radio.component';
import { RangeFilterFieldComponent } from './range/filter-field-range.component';
import { SearchSelectFilterFieldComponent } from './search-select/filter-field-search-select.component';
import { TextFilterFieldComponent } from './text/filter-field-text.component';

const FilterMap: { [type: string]: Type<FilterFieldComponent<FilterField<any>>> } = {
  checkbox: CheckboxFilterFieldComponent,
  'search-select': SearchSelectFilterFieldComponent,
  'date-picker': DatePickerFilterFieldComponent,
  'items-and-status': ItemsAndStatusFilterFieldComponent,
  'multi-items-and-status': MultiItemsAndStatusFilterFieldComponent,
  'multi-select': MultiSelectFilterFieldComponent,
  range: RangeFilterFieldComponent,
  radio: RadioFilterFieldComponent,
  text: TextFilterFieldComponent,
};

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[filter]',
  standalone: false,
})
export class FilterFieldDirective implements OnInit {
  @Input() filterField: FilterField<any>;
  @Output() filterApplied = new EventEmitter<FilterField<any>>();

  component: ComponentRef<FilterFieldComponent<FilterField<any>>>;

  constructor(private container: ViewContainerRef) {}

  ngOnInit(): void {
    if (!this.component) {
      this.initializeComponent();
    }
  }

  initializeComponent(): void {
    if (!this.filterField) {
      return; // Component was constructed before the filterField input was ready
    }

    this.component = this.container.createComponent<FilterFieldComponent<FilterField<any>>>(
      FilterMap[this.filterField.type],
    );
    this.component.instance.filterField = this.filterField;
    this.component.instance.filterApplied.subscribe((value: any) => this.filterApplied.emit(value));
  }
}
